export default {
    getUserAfm: state => state.userAFM,
    isLoggedIn: state => !!state.token,
    isEmailVerified: state => state.user.isEmailVerified,
    isTaxisChecked: state => state.isTaxisChecked,
    authStatus: state => state.status,
    getToken: state => state.token,
    user: state => state.user,
    userRole: state => state.role,
    isAdmin: state => state.role === 'ROLE_ADMIN' || state.role === 'ROLE_SUPERADMIN',
    isTaxisAddrVerified: state => state.user.isTaxisAddrVerified ? state.user.isTaxisAddrVerified : null,
    userID: state => (state.user.iduser) ? state.user.iduser : null,
    yphrKwd: state => (state.user.yphrKwd) ? state.user.yphrKwd : null,
    mebelongs: state => (state.user.mebelongs) ? state.user.mebelongs : null,
    hasEfp: state => state.user.hasEfp,
    efsa: state => (state.user.efsa) ? state.user.efsa : null,
    meeResponsible: state => (state.user.meeResponsible) ? state.user.meeResponsible : null,
    monadaLek: state => (state.user.monadaLek) ? state.user.monadaLek : null
}